import { IPropsWithChildren } from '@omaze/app';
import { default as React, ReactElement } from 'react';

import styles from './LoadingSpinner.module.css';
import { loadingSpinnerDisplayName } from './LoadingSpinner.qa';

const spinnerRange: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export enum SPINNER_SIZE {
    EXTRA_SMALL = 'xsmall',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    EXTRA_LARGE = 'xlarge',
}
export interface ILoadingSpinnerProps extends IPropsWithChildren {
    className?: string;
    'data-testid'?: string;
    size?: SPINNER_SIZE;
}

export function OzLoadingSpinner (props: ILoadingSpinnerProps): ReactElement {
    const {
        'data-testid': dataTestId,
        className,
        size,
    }: ILoadingSpinnerProps = props;

    return (
        <div className={`flex flex-col items-center ${styles.spinner} ${className || ''}`} data-testid={dataTestId || ''}>
            <div className={styles.spinner__icon}>
                <div className={`${styles['sk-fading-circle']} ${styles[size || SPINNER_SIZE.SMALL]}`}>
                    {
                        spinnerRange.map((val: number): ReactElement => {
                            return <div key={val} className={`${styles['sk-circle']} ${styles[`sk-circle-${val}`]}`}></div>;
                        })
                    }
                </div>
            </div>
        </div>
    );
}

OzLoadingSpinner.displayName = loadingSpinnerDisplayName;
